import { Info } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const ImagesInfo = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-info rounded-lg flex mb-4 p-4 md:p-5">
            <Info classNames="w-8 h-8 flex-none -mt-1 mr-4 -ml-1" />
            <p className="">{t('Content.Overview.Images.Info')}</p>
        </div>
    );
};
